// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

// unpoly-bootstrap3/feedback-ext (extracted to skip modal extension)
up.feedback.config.currentClasses.push('active')

// unpoly-bootstrap3/form-ext (extracted to skip modal extension)
up.form.config.groupSelectors.unshift('.form-group:has(&)')

up.form.config.submitSelectors.push('form')

up.fragment.config.runScripts = false
up.network.config.progressBar = true

// unpoly-bootstrap3/viewport-ext (extracted to skip modal extension)
up.viewport.config.fixedTopSelectors.push('.navbar-fixed-top')
up.viewport.config.fixedBottomSelectors.push('.navbar-fixed-bottom')
up.viewport.config.anchoredRightSelectors.push('.navbar-fixed-top')
up.viewport.config.anchoredRightSelectors.push('.navbar-fixed-bottom')
up.viewport.config.anchoredRightSelectors.push('.footer')

up.history.config.updateMetaTags = true

// Only do this in development. This requires a `[data-environment="development"]` attribute on your `<body>` element.
// See https://makandracards.com/makandra/1433-detect-the-current-rails-environment-from-javascript-or-css
if (document.body.dataset.environment === 'development') {
  // Returns true when your development server shows an error page.
  function isDevelopmentError(response) {
    return !response.ok && /Full backtrace|Better errors/.test(response.text)
  }

  // When the development server shows an error page, repeat the request as a full page load.
  up.on('up:fragment:loaded', function(event) {
    if (isDevelopmentError(event.response)) {
      event.preventDefault() // Prevent the fragment from being updated
      if (event.request.params.toArray().some(({ name, value }) => value instanceof Blob)) {
        up.network.loadPage({ url: '/__better_errors' }) // Unpoly can't resubmit requests with files
      } else {
        event.request.loadPage()
      }
    }
  })
}
